/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from 'react';
import { ARMcontext } from '../../../utils/context/context';
import { useHistory } from 'react-router-dom';
import { FluidContainer, TableFreshStrength, TableFreshROM, Radio, Tag, Loader, Modal } from '../../../components';
import {
  RadiosContainer,
  TableWrapper,
  RadiosWrapper,
  ArmRecoveryContainer,
  TextContainer,
  AlertContainer,
  AlertWrapper,
  Oval,
  ExamInfoContainer,
  ExamInfoUnit,
  ExamRadios,
  ArmRecoveryInfoButton,
  ArmRecoveryTop,
  ArmRecoveryInfoTitle,
  ArmRecoveryInfoSubtitle,
  ArmRecoveryInfoText,
  ArmRecoveryInfoSpan,
  ArmRecoveryInfoSection,
  ModalBottom,
  ModalBottomLabels,
} from '../styles';
import { Teams } from '../../../utils/api';
import TablePostStr from '../../../components/Table/TablePostStrength';
import TablePostROM from '../../../components/Table/TablePostROM';
import TablePrimer from '../../../components/Table/TablePrimer';
import { capitalizeFirstLetters } from '../../../utils/hooks/text-formatter';
import { TableColumn, TableRow, TableSubHeader, TableTopHeader, TableUnit, TableHead, TableBody } from '../../../components/Table/styles';
import { ArmRecovery, ArmFatigue, ArmReadiness } from '../../../utils/constants/fatigueZonesInfo';

export default ({
  isFirstLoad,
  playersGroup,
  playerNameSearch,
  alerts,
  useDefaultAlerts,
  useAlerts,
}: {
  isFirstLoad: boolean;
  playersGroup: any;
  playerNameSearch: any;
  alerts: any;
  useDefaultAlerts: any;
  useAlerts: any;
}) => {
  const history = useHistory();
  let path = useHistory().location.pathname;
  let initialExam = { fresh: true, post: false, primer: false };
  if (path.includes('post')) {
    initialExam = { fresh: false, post: true, primer: false };
  } else if (path.includes('armPrimer')) {
    initialExam = { fresh: false, post: false, primer: true };
  }
  let initialSubExam = path.includes('rom') ? { strength: false, rom: true } : { strength: true, rom: false };
  const [exams, useExams] = useState<Array<object | any>>([]);
  const [postExams, usePostExams] = useState<any>();
  const [postAverage, usePostAverage] = useState<any>();
  const [primerExams, usePrimerExams] = useState<Array<object | any>>([]);
  const [primerAverage, usePrimerAverage] = useState<any>();
  const [radioExams, useRadioExams] = useState<any>(initialExam);
  const [radio, useRadio] = useState<any>(initialSubExam);
  const [averageInfo, useAverage] = useState<object | any>({});
  const { selectedTeam } = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const [loadingSecondTable, setLoadingSecondTable] = useState(true);
  const [loadingThirdTable, setLoadingThirdTable] = useState(true);
  const [fatigueModal, setFatigueModal] = useState(false);
  const [isFirstLoadExams, setFirstLoadExams] = useState(true);
  const [modalInfo, setModalInfo] = useState<any>(initialExam.fresh ? ArmRecovery : initialExam.post ? ArmFatigue : ArmReadiness);
  const TEAMS = new Teams();

  useEffect(() => {
    if (!isFirstLoad || isFirstLoadExams) FetchExams();
  }, [selectedTeam._id, playersGroup]);

  useEffect(() => {
    setFirstLoadExams(false)
    let loc = history.location.pathname;
    if (loc.substring(loc.length - 5, loc.length) === 'exams') {
      history.replace('/players/exams/fresh/strength');
    }
  }, []);

  async function hidePlayer(playerId, action) {
    const response = await TEAMS.HidePlayer(playerId, action);
    if (response.status) {
      await FetchExams();
    }
  }

  function HandleRadioExams(e: any) {
    if (e.target.id === 'fresh') {
      history.replace('/players/exams/fresh/strength');
      useRadio({ strength: true, rom: false });
      useRadioExams({ fresh: true, post: false, primer: false });
      setModalInfo(ArmRecovery);
    } else if (e.target.id === 'post') {
      history.replace('/players/exams/post/strength');
      useRadio({ strength: true, rom: false });
      useRadioExams({ fresh: false, post: true, primer: false });
      setModalInfo(ArmFatigue);
    } else if (e.target.id === 'primer') {
      history.replace('/players/exams/armPrimer');
      useRadio({ strength: true, rom: false });
      useRadioExams({ fresh: false, post: false, primer: true });
      setModalInfo(ArmReadiness);
    }
  }

  function HandleRadioExamTypes(e: any): void {
    let lastSlash = String(history.location.pathname).lastIndexOf('/');
    let root = String(history.location.pathname).substring(0, lastSlash + 1);

    if (e.target.id === 'Strength') {
      history.replace(root + 'strength');
      useRadio({ strength: true, rom: false });
    } else {
      history.replace(root + 'rom');
      useRadio({ strength: false, rom: true });
    }
  }

  async function fetchPostExams(): Promise<void> {
    let exams = await TEAMS.GetPostExams(selectedTeam._id, playersGroup);
    if (exams.status) {
      usePostExams(exams.data.data.entries);
      usePostAverage(exams.data.data.teamSummary);
      setLoadingTable(false);
      return exams.data;
    }
  }

  async function fetchPrimerExams(): Promise<void> {
    let exams = await TEAMS.GetPrimerExams(selectedTeam._id, playersGroup);
    if (exams.status) {
      usePrimerExams(exams.data.data.entries);
      usePrimerAverage(exams.data.data.teamSummary);
      setLoadingSecondTable(false);
      return exams.data;
    }
  }

  async function fetchExams(): Promise<void> {
    let exams = await TEAMS.GetExams(selectedTeam._id, alerts.value, playersGroup);
    if (exams.status) {
      exams.data.records.map(item => {
        item.summary.romTotalArc = item.summary.shoulderIR90ThrowDegrees + item.summary.shoulderER90ThrowDegrees || undefined;
        return item;
      });

      useExams(exams.data.records);
      useAverage(exams.data.teamAverage);
      setLoadingThirdTable(false);
      return exams.data;
    }
  }

  async function FetchExams(): Promise<void> {
    setLoadingTable(true);
    setLoadingSecondTable(true);
    setLoadingThirdTable(true);
    let promises = [fetchPostExams(), fetchPrimerExams(), fetchExams()];

    await Promise.allSettled(promises);

  }

  function SetModalBottom(info) {
    let rows = Object.entries(info.info.zones);
    return (
      <ModalBottom>
        <ModalBottomLabels>
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
              {capitalizeFirstLetters(row[0], ' ')}
            </React.Fragment>
          ))}
        </ModalBottomLabels>
        <TableUnit color="black">
          <TableHead>
            <TableRow>
              <TableTopHeader hide={true}></TableTopHeader>
              <TableTopHeader colSpan={5} color="black">
                {String(info.info.title).toUpperCase()}
              </TableTopHeader>
            </TableRow>
            {info.info.categories && (
              <TableRow>
                <TableSubHeader hide={true} border={'none'}></TableSubHeader>
                {info.info.categories.map(category => (
                  <TableSubHeader key={category}>{category}</TableSubHeader>
                ))}
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} bgColor={row[0]}>
                <TableColumn width={'0px'}>
                  <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
                </TableColumn>
                {Object.values(Object(row[1])).map((col, colIndex) => (
                  <TableColumn key={colIndex}>{String(col)}</TableColumn>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </TableUnit>
      </ModalBottom>
    );
  }

  return (
    <FluidContainer>
      <RadiosWrapper>
        <ExamRadios>
          <RadiosContainer onClick={HandleRadioExams} mBottom={'15px'}>
            <Radio
              theme="button"
              title="FRESH EXAM"
              name="radioExams"
              id="fresh"
              checked={radioExams.fresh}
              dynamicActive={radioExams.fresh}
              size={'16px'}
            />
            <Radio
              theme="button"
              title="POST EXAM"
              name="radioExams"
              id="post"
              checked={radioExams.post}
              dynamicActive={radioExams.post}
              size={'16px'}
            />
            <Radio
              theme="button"
              title="ARM PRIMER"
              name="radioExams"
              id="primer"
              checked={radioExams.primer}
              dynamicActive={radioExams.primer}
              size={'16px'}
            />
          </RadiosContainer>
        </ExamRadios>
        <ExamInfoContainer>
          <ArmRecoveryContainer>
            {!(radioExams.post && radio.rom) && (
              <>
                <ArmRecoveryTop>
                  {radio.rom ? (
                    <TextContainer>ROM ALERTS</TextContainer>
                  ) : radioExams.fresh ? (
                    <TextContainer>ARM RECOVERY</TextContainer>
                  ) : radioExams.post ? (
                    <TextContainer>ARM FATIGUE</TextContainer>
                  ) : (
                    <TextContainer>ARM READINESS</TextContainer>
                  )}
                  {!radio.rom && <ArmRecoveryInfoButton onClick={() => setFatigueModal(true)}>i</ArmRecoveryInfoButton>}
                </ArmRecoveryTop>
                <AlertWrapper>
                  <AlertContainer>
                    <Oval size={'8'} color={'watch'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'warning'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    {!radioExams.post && !radio.rom && (
                      <>
                        <Oval size={'8'} color={'medical'} />
                        <span> Medical</span>
                      </>
                    )}
                  </AlertContainer>
                </AlertWrapper>
              </>
            )}
          </ArmRecoveryContainer>
          {!radioExams.primer && (
            <RadiosContainer onChange={HandleRadioExamTypes}>
              <Radio title={`Strength`} name="radioExam" id={'Strength'} checked={radio.strength} dynamicActive={radio.strength} />
              <Radio title={`Range of motion`} name="radioExam" id={'Range of motion'} checked={radio.rom} dynamicActive={radio.rom} />
            </RadiosContainer>
          )}
          <ExamInfoUnit>
            <span>Unit of measure</span>
            {radio.strength && <Tag name={'Lbs'} theme={'Info'} />}
            {radio.rom && <Tag name={'Degrees'} theme={'Info'} />}
          </ExamInfoUnit>
        </ExamInfoContainer>
      </RadiosWrapper>
      <TableWrapper>
        <>
          {radioExams.fresh && (
            <>
              {loadingThirdTable ? (
                <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
                  <Loader height="90px" />
                </div>
              ) : (
                <>
                  {radio.strength && (
                    <TableFreshStrength
                      minWidth="1200px"
                      dataTableContent={exams}
                      dataAverage={averageInfo}
                      filter={playerNameSearch}
                      dataCy={'exam-summary-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                    />
                  )}
                  {radio.rom && (
                    <TableFreshROM
                      minWidth="1200px"
                      dataTableContent={exams}
                      dataAverage={averageInfo}
                      filter={playerNameSearch}
                      dataCy={'exam-rom-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                    />
                  )}
                </>
              )}
            </>
          )}
          {radioExams.post && (
            <>
              {loadingTable ? (
                <>
                  <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
                    <Loader height="90px" />
                  </div>
                </>
              ) : (
                <>
                  {radio.strength && (
                    <TablePostStr
                      minWidth="1200px"
                      dataTableContent={postExams}
                      dataAverage={postAverage?.strength}
                      filter={playerNameSearch}
                      dataCy={'exam-summary-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                    />
                  )}
                  {radio.rom && (
                    <TablePostROM
                      minWidth="1200px"
                      dataTableContent={postExams}
                      dataAverage={postAverage?.rom}
                      filter={playerNameSearch}
                      dataCy={'exam-rom-table'}
                      fatigueZone={false}
                      hidePlayer={hidePlayer}
                    />
                  )}
                </>
              )}
            </>
          )}

          <>
            {radioExams.primer && (
              <>
                {loadingSecondTable ? (
                  <>
                    <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
                      <Loader height="90px" />
                    </div>
                  </>
                ) : (
                  <>
                    <TablePrimer
                      minWidth="1200px"
                      dataTableContent={primerExams}
                      dataAverage={primerAverage}
                      filter={playerNameSearch}
                      dataCy={'exam-rom-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                    />
                  </>
                )}
              </>
            )}
          </>
        </>
      </TableWrapper>
      {fatigueModal && (
        <Modal active={setFatigueModal} padding={'20px 44px'} maxWidth={'480px'} width={'80vw'} margin={'40px auto'} minWidth={'480px'}>
          {radioExams.fresh && (
            <>
              <ArmRecoveryInfoTitle>ARM RECOVERY</ArmRecoveryInfoTitle>
              <ArmRecoveryInfoSubtitle>Change from average (lbs)</ArmRecoveryInfoSubtitle>
              <ArmRecoveryInfoText>
                A change in your weekly average Fresh exam indicates your throwing arm recovery. Total arm strength decreases need to be
                less than
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>and less than<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
                from average for each individual muscle.
                <br></br>
                <br></br>
                If total strength decreases
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>or more or<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
                or more for each muscle group, you are showing signs that your recovery is less than optimal. Reducing pitch counts,
                pushing bullpens back and lower throwing intensity can help improve recovery.
                <br></br>
                <br></br>
                Recomendations:
                <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
                Reduce throwing workloads while you increase strength and evaluate recovery habits.
                <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
                Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase strength.
                <ArmRecoveryInfoSection>MEDICAL</ArmRecoveryInfoSection>
                Seek evaluation by a licensed medical professional.
              </ArmRecoveryInfoText>
            </>
          )}
          {radioExams.post && (
            <>
              <ArmRecoveryInfoTitle>ARM FATIGUE</ArmRecoveryInfoTitle>
              <ArmRecoveryInfoText>
                Arm Fatigue is determined by strength evaluations after high intensity throwing days to understand how fatigued your
                throwing arm becomes after games, bullpens, and velocity training days.
                <br></br>
                <br></br>
                The goal is to retain more than
                <ArmRecoveryInfoSpan>{' 90% '}</ArmRecoveryInfoSpan>
                of your strength from Fresh Exams
                <ArmRecoveryInfoSpan>{' (%Fresh) '}</ArmRecoveryInfoSpan>. If you cannot retain
                <ArmRecoveryInfoSpan>{' 90% '}</ArmRecoveryInfoSpan>
                of your Fresh strength, you may need to lower your workload and spend more time building strength and endurance.
                <br></br>
                <br></br>
                Recomendations:
                <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
                Reduce throwing workloads for your next high intensity throwing day. For example if strength was not retained on the game
                day, lower pitch counts on your next bullpen/game day/velo day, but maintain strength training.
                <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
                Reduce throwing workloads for your next high intensity throwing day. In addition to making adjustments to your next high
                intensity throwing day, you need to focus on recovery habits and strength. It is a good idea after a Warning to make the
                next day a low intensity throwing day or a complete day of rest.
              </ArmRecoveryInfoText>
            </>
          )}
          {radioExams.primer && (
            <>
              <ArmRecoveryInfoTitle>ARM READINESS</ArmRecoveryInfoTitle>
              <ArmRecoveryInfoText>
                A change in daily Arm Primer strength from a <ArmRecoveryInfoSpan>{' 7-day '}</ArmRecoveryInfoSpan>average indicates your
                pre-throwing strength status. Total primer strength decreases need to be less than
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>and less than<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
                from the average for each individual test. If total primer strength decreases
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>or more or<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>or
                more for each test, you are showing signs that your pre-throwing strength is less than optimal.
                <br></br>
                <br></br>
                Combined with wellness data, evaluate how the arm feels and also note poor sleep and body soreness in deciding when to
                reduce pitch counts, push bullpens back and lower throwing intensity. Also consider programming adjustments for long-lever
                strength.
                <br></br>
                <br></br>
                Recomendations:
                <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
                Reduce throwing workloads while you increase strength and evaluate recovery habits.
                <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
                Skip a start, bullpen and high intensity weighted ball programming while training is intensified to increase strength.
                <ArmRecoveryInfoSection>MEDICAL</ArmRecoveryInfoSection>
                Seek evaluation by a licensed medical professional.
              </ArmRecoveryInfoText>
            </>
          )}
          <SetModalBottom info={modalInfo} />
        </Modal>
      )}
    </FluidContainer>
  );
};
